import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import { toast } from "react-toastify";
import useUpdateUserPassowrdByUserIdMutation from "@/GraphQL/hooks/mutations/useUpdateUserPassowrdByUserIdMutation";
import PasswordChangeForm from "./PasswordChangeForm";

const ChangePasswordModal = ({ isOpen, toggle, userId }) => {
  const { updateUserPassowrdByUserId, loading } =
    useUpdateUserPassowrdByUserIdMutation();

  const onCancel = () => {
    toggle(); // close modal
  };

  const onSubmit = async (data) => {
    const { password, c_password } = data;

    if (password !== c_password) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await updateUserPassowrdByUserId({
        variables: {
          id: userId,
          password,
        },
      });

      const { message, status_code } =
        res?.data?.updateUserPassowrdByUserId || {};

      if (status_code === 202) {
        toast.success(message);
        toggle(); // close modal
      } else {
        toast.error(message || "Something went wrong");
      }
    } catch (err) {
      toast.error("Failed to update password");
    }
  };

  return (
    <Modal
      style={{ maxWidth: "500px", width: "100%" }}
      className="modal-sm-custom"
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>Change Password</ModalHeader>
      <ModalBody>
        <PasswordChangeForm
          onCancel={onCancel}
          onSubmit={onSubmit}
          loading={loading}
        />
      </ModalBody>
    </Modal>
  );
};

export default ChangePasswordModal;
